const debounce = require("app/util/debounce");

function createPromiseThrottle(amount) {
	let promise;
	let resolve;
	let reject;

	const resolver = debounce(amount, payload => {
		if (promise) {
			promise = null;
			resolve(payload);
		}
	});

	return (payload) => {
		if (promise) {
			promise = null;
			reject();
		}

		promise = new Promise((res, rej) => {
			resolve = res;
			reject = rej;
		});

		// Attempt to resolve
		resolver(payload);

		return promise;
	};
}

module.exports = {
	createPromiseThrottle
};